import { ISetting } from '../interfaces';

export const getValue = <T>(
  settingValues: Array<ISetting>,
  alias: string,
  defaultValue: T
): T extends string
  ? string
  : T extends number
  ? number
  : T extends boolean
  ? boolean
  : T => {
  const setting = settingValues.find(
    (setting: ISetting) => setting.alias === alias
  )?.value;

  if (typeof defaultValue === 'string') {
    // @ts-ignore проблема typescript, в данном случае возвращается такой же тип, как и defaultValue
    return setting;
  }

  try {
    const value = JSON.parse(setting as string);

    if (typeof defaultValue === 'boolean') {
      // @ts-ignore проблема typescript, в данном случае возвращается такой же тип, как и defaultValue
      return value === 1;
    }

    // @ts-ignore проблема typescript, в данном случае возвращается такой же тип, как и defaultValue
    if (value === null) return defaultValue;

    // @ts-ignore проблема typescript, в данном случае возвращается такой же тип, как и defaultValue
    return value;
  } catch (e) {
    if (defaultValue === null) {
      // @ts-ignore проблема typescript, в данном случае возвращается такой же тип, как и defaultValue
      return setting;
    }

    // @ts-ignore проблема typescript, в данном случае возвращается такой же тип, как и defaultValue
    return defaultValue;
  }
};
